import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { ModalContext } from '~providers/ModalContext'
import scssVars from '~components/scss-variables'
import { ReusableModal } from '~components/Modals/Modal'
import { Picture as DefaultPicture } from '~components/Services/Intro'

import mailIn from '../../../static/img/estimates-img/27_Box@2x.png'
import van from '../../../static/img/estimates-img/28_Van@2x.png'
import dropOff from '../../../static/img/estimates-img/29_Map_04@2x.png'


const Wrapper = styled.div`
  cursor: pointer;
  margin-bottom: 1rem;
`

const Picture = styled(DefaultPicture)`
  max-height: 50px;
  margin-bottom: 20px;
`

const ModalWrapper = styled.div`
  overflow-y: auto;
`

const ModalContentWrapper = styled.div`
  padding: 3rem 3rem 3rem 3rem;
  text-align: center;
    line-height: 1.375;

  h4 {
    color: ${scssVars.orange};
    margin-bottom: 1rem;
  }

  p:last-child {
    margin-bottom: 0;
  }
`

const ModalFooter = styled.div`
  background-color: ${scssVars.gray};
  text-align: center;
  padding: 1rem 1.25rem 1.25rem;

  p {
    margin: 0;
  }
`

const MailInContent = () => {

  return (
    <ModalWrapper>
      <ModalContentWrapper>
        <Picture mobileSrc={mailIn} src={mailIn} />
        <h4>Drop off at The UPS Store</h4>
        <p>
          Simply bring to any UPS Store within the continental US.
          They will handle the packing, labeling, and shipping of your repair order.
          We'll email you a drop off confirmation code and instructions.
          Print out or show it on your smartphone to a store associate at The UPS Store.
      </p>
        <p>
          Free return shipping is included with this option.
          Includes package insurance up to $2,500.00 to and from Leather Spa.
      </p>
      </ModalContentWrapper>
      <ModalFooter>
        <p>For more information on this service, please check out our <a className="text-link" target="_blank" href="https://leatherspa.zendesk.com/hc/en-us/articles/360057155573-The-UPS-Store-Drop-Off-Program">help center</a> article.</p>
      </ModalFooter>
    </ModalWrapper>
  )
}

const PickUpContent = () => {
  return (
    <ModalWrapper>
      <ModalContentWrapper style={{ paddingBottom: '1rem' }}>
        <Picture mobileSrc={van} src={van} />
        <h4>Pickup Service</h4>
        <p>
          We offer two types of pickup services:
        </p>
        <h6>Standard Pick-Up Service</h6>
        <p>
          No set time. Next business day pick up between 10 am and 7 pm.
        </p>
        <h6>On-Demand Pick-Up Service</h6>
        <p>
          Schedule a pickup date and time that works for you. We will pick up your item(s) within the two-hour window you select.
        </p>
        <p>
          Both options Include return delivery to the same address.
        </p>
        <p>
          <strong>
            NEW! We can pick up larger leather goods.
          </strong>
        </p>
      </ModalContentWrapper>
      <ModalFooter>
        <p>Please contact us at <a className="text-link" href="mailto:repairs@leatherspa.com">repairs@leatherspa.com</a> to schedule a special or larger item pickup.</p>
      </ModalFooter>
    </ModalWrapper>
  )
}

const DropOffContent = () => {
  return (
    <ModalWrapper>
      <ModalContentWrapper>
        <Picture mobileSrc={dropOff} src={dropOff} />
        <h4>Express Drop-Off Service</h4>
        <p>
          Skip the line and try our Express Drop-Off Service.
        </p>
        <h6>How it works:</h6>
        <p>
        Simply start a repair order online and drop off your item(s) at any of our
        locations with the assigned repair order number and we will take care of the rest via our online platform.
      </p>
      </ModalContentWrapper>
    </ModalWrapper>
  )
}

export const ReadMoreToggle = ({ children, setModalContentType }) => {
  const { toggleModal } = useContext(ModalContext)
  const Text = styled.p`
    display: inline;
    margin: 0;
    color: ${scssVars.orange};
    font-style: italic;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 500;
    text-decoration: underline;
    transition: 0.3s color;
    &:hover, &:active {
      color: ${scssVars.darkBrown};
    }
  `
  return (
    <Wrapper
      onClick={() => {
        setModalContentType()
        toggleModal(true)
      }}>
      <Text>{children}</Text>
    </Wrapper>
  )
}

export const ShippingInfoPopup = ({ contentId }) => {
  const { modalOpen, toggleModal } = useContext(ModalContext)

  return (
    <ReusableModal isOpen={modalOpen} toggleModal={toggleModal}>
      {contentId === 'mailIn' &&
        <MailInContent />
      }

      {contentId === 'pickUp' &&
        <PickUpContent />
      }

      {contentId === 'dropOff' &&
        <DropOffContent />
      }
    </ReusableModal>
  )
}

ReadMoreToggle.propTypes = {
  children: PropTypes.string,
}

ShippingInfoPopup.propTypes = {
  children: PropTypes.element.isRequired,
}
